import { render, staticRenderFns } from "./T1GalleryLightbox.vue?vue&type=template&id=3552436e&scoped=true&"
import script from "./T1GalleryLightbox.vue?vue&type=script&lang=js&"
export * from "./T1GalleryLightbox.vue?vue&type=script&lang=js&"
import style0 from "./T1GalleryLightbox.vue?vue&type=style&index=0&id=3552436e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3552436e",
  null
  
)

export default component.exports